import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FormDialogContainerComponent } from '../containers/form-dialog-container/form-dialog-container.component';
import { FormDialogOptions } from '../models/form-dialog-options';

@Injectable({
  providedIn: 'root',
})
export class FormDialogService {
  constructor(private dialog: MatDialog) {}

  open<T>(options: FormDialogOptions): Observable<T> {
    const dialogOption: MatDialogConfig<FormDialogOptions> = {
      width: '500px',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      position: { top: '0', right: '0' },
      disableClose: false,
      panelClass: options.currentThemeMode === 'dark' ? ['dark-theme', 'form-panel'] : ['light-theme', 'form-panel'],
      autoFocus: false,
      data: options,
    };

    return this.dialog.open(FormDialogContainerComponent, dialogOption).beforeClosed();
  }
}
